import DeleteIcon from "../../images/icon_delete.svg";
import PDFIcon from "../../images/icon_pdf.svg";
import UploadIcon from "../../images/icon_upload_file.svg";
import { FILE_FORMATS } from "../../utils/constants";
import FileDropArea from "../FileDropArea/FileDropArea";
import {
  DashedRowVoucher,
  FileInfoVoucher,
  RowContainerVoucher,
} from "./ContadoMethodStyles";

export const formatSize = (bytes) => {
  if (bytes < 1000000) return Math.max(Math.round(bytes / 1000), 1) + " KB";
  if (bytes < 1000000000)
    return Math.round((bytes / (1000 * 1000)) * 10) / 10 + " MB";
  return "More than 1GB";
};

const FileUploadInputDirectMethod = (props) => {
  const { onValueChange, value, maxFiles, formats, width, height, disabled } =
    props;
  const appendFiles = (newFiles) => {
    onValueChange([...value, ...newFiles].slice(0, maxFiles || 1));
  };

  const removeFile = (deleteIdx) => {
    onValueChange(value.filter((_, idx) => idx !== deleteIdx));
  };

  const extensions = formats.flat().map((format) => {
    return typeof format === "object" ? format.extension : format;
  });
  const accepts = formats.flat().map((format) => {
    return typeof format === "object" ? format.accept : format;
  });

  return (
    <>
      {value.map((file, idx) => {
        return (
          <FileInfoVoucher key={idx}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: `${width}`,
                justifyContent: "space-between",
              }}
            >
              <div>
                <img src={PDFIcon} alt="PDFIcon" />
              </div>
              <div>
                <p style={{ overflowWrap: "break-word", width: "38rem" }}>
                  {file.name}
                </p>
              </div>
              <div>
                <p className="size">{formatSize(file.size)}</p>
              </div>
              <div>
                <img
                  style={{ cursor: "pointer" }}
                  className="delete-icon"
                  src={DeleteIcon}
                  alt="DeleteIcon"
                  onClick={() => removeFile(idx)}
                />
              </div>
            </div>
          </FileInfoVoucher>
        );
      })}
      {value.length < maxFiles && (
        <RowContainerVoucher width={width} height={height}>
          <FileDropArea
            onDrop={appendFiles}
            formats={accepts || [FILE_FORMATS.PDF, FILE_FORMATS.IMAGE]}
            validExtensions={extensions}
            disabled={disabled}
          >
            <DashedRowVoucher>
              <img src={UploadIcon} alt="UploadIcon" />
              <div style={{ width: "42rem" }}>{props.description}</div>
            </DashedRowVoucher>
          </FileDropArea>
        </RowContainerVoucher>
      )}
    </>
  );
};

export default FileUploadInputDirectMethod;
